import { render } from "./ClassTimingDistributionChart.vue?vue&type=template&id=491ad5c4&scoped=true"
import script from "./ClassTimingDistributionChart.vue?vue&type=script&lang=js"
export * from "./ClassTimingDistributionChart.vue?vue&type=script&lang=js"

import "./ClassTimingDistributionChart.vue?vue&type=style&index=0&id=491ad5c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-491ad5c4"

export default script